<ul>
    <li>
        <a [routerLink]="['/test', 'invoiceapproval', 0]">Rechnungsfreigabe Ansicht 1</a>
    </li>
    <li>
        <a [routerLink]="['/test', 'invoiceapproval', 1]">Rechnungsfreigabe Ansicht 2</a>
    </li>
</ul>
